"use client";

import Link from 'next/link';

export default function NotFound() {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--color-main-light)', zIndex: 9999 }}>
      <div style={{ textAlign: 'center', padding: 'var(--space-7)', maxWidth: '600px' }}>
        <h1 className="heading-2" style={{ color: 'var(--color-main-dark)', margin: '0 0 var(--space-5) 0' }}>Not Found</h1>
        <p className="body-2" style={{ color: 'var(--color-main-dark-600)', margin: '0 0 var(--space-8) 0' }}>The page you are looking for does not exist.</p>
        <Link href="/stories-of-us" className="body-2-sans-bold" style={{ color: 'var(--color-ui-green)', textDecoration: 'underline' }}>Return Home</Link>
      </div>
    </div>
  );
}
